import axios from 'axios'
import qs from 'qs'
import store from '@/store/store'

const seec_api = process.env.VUE_APP_SEEC_API

// interceptor on request
axios.interceptors.request.use(function (request) {
  if (request.url.startsWith('http://geoserverhml.eparana.parana') ||
    request.url.startsWith('http://geoserverdes.eparana.parana') ||
    request.url.startsWith('http://geoserver.pr.gov.br')) { // FIXME
    return request
  }

  if (store.getters.getUser && JSON.parse(store.getters.getUser).token.access_token) {
    request.headers.Authorization = `Bearer ${JSON.parse(store.getters.getUser).token.access_token}`
  }

  return request
},
function (error) {
  return Promise.reject(error)
})

// interceptor on response
axios.interceptors.response.use(function (response) {
  return response
},
function (error) {
  if (error == 'Error: Network Error') {
    if (error.response == undefined) {
      var networkError = { response: { data: { message: 'Algum recurso necessário para execução desta funcionalidade encontra-se indisponível.' } } }
      error = networkError
    }
  }

  if (error.response != undefined && error.response.status === 403) {
    var permissionError = { response: { data: { message: '403 - Sem acesso a alguns recursos desta funcionalidade.' } } }
    error = permissionError
  }

  return Promise.reject(error)
})

export default {
  // Municípios
  getMunicipios (params) {
    return axios.get(`${seec_api}/municipios`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  // Agentes Culturais
  getAgente (params) {
    return axios.get(`${seec_api}/agente/agente`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getCategoriaAgente () {
    return axios.get(`${seec_api}/agente/categoria`)
  },
  getAreaAgente () {
    return axios.get(`${seec_api}/agentes/area`)
  },
  getCategoria (params) {
    return axios.get(`${seec_api}/agente/categoria_agente`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  // Agentes Culturais (SIC CULTURA)
  getAgentes (params) {
    return axios.get(`${seec_api}/agentes`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  // Equipamentos Culturais (SIC CULTURA)
  getEquipamentos (params) {
    return axios.get(`${seec_api}/equipamentos`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getTiposAtividade (tipoEquipamento) {
    return axios.get(`${seec_api}/equipamentos/tipos_atividade`, {
      params: {
        'tipo_equipamento': tipoEquipamento
      },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
    })
  },
  // Equipamentos Culturais
  getEquipamento (params) {
    return axios.get(`${seec_api}/equipamento/equipamento`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getTipoEquipamento () {
    return axios.get(`${seec_api}/equipamento/tipo_equipamento`)
  },
  getRecurso (tipoEquipamento) {
    return axios.get(`${seec_api}/equipamento/recurso`, {
      params: {
        tipo_equipamento: tipoEquipamento
      },
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat'
      })
    })
  },
  getEspecificacao (tipoEquipamento) {
    return axios.get(`${seec_api}/equipamento/especificacao`, {
      params: {
        'tipo_equipamento': tipoEquipamento
      },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
    })
  },
  getServico (tipoEquipamento) {
    return axios.get(`${seec_api}/equipamento/servico`, {
      params: {
        'tipo_equipamento': tipoEquipamento
      },
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat'
      })
    })
  },

  // Meios de Comunicação
  getTipoMeioComunicacao () {
    return axios.get(`${seec_api}/meio_comunicacao/tipo_equipamento`)
  },
  getMeioComunicacao (params) {
    return axios.get(`${seec_api}/meio_comunicacao/meio_comunicacao`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },

  // Atividades
  getAtividade (params) {
    return axios.get(`${seec_api}/atividade/atividade`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getTipoAtividade () {
    return axios.get(`${seec_api}/atividade/tipo_atividade`)
  },

  // Patrimônios Culturais
  getPatrimonio (params) {
    return axios.get(`${seec_api}/patrimonio/patrimonio`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getOrgao() {
    return axios.get(`${seec_api}/orgao/listar`)
  },
  getTipoPatrimonio () {
    return axios.get(`${seec_api}/patrimonio/tipo_patrimonio`)
  },
  getClassificacao (params) {
    return axios.get(`${seec_api}/patrimonio/classificacao`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getFotos (patrimonio) {
    return axios.get(`${seec_api}/patrimonio/foto`, {
      params: {
        patrimonio
      },
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getLocalizacoes (params) {
    return axios.get(`${seec_api}/patrimonio/localizacao`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },

  // Perfil Gestor
  getTipoPerfilGestor () {
    return axios.get(`${seec_api}/perfil_gestor/tipo_perfil_gestor`)
  },

  // Conselho Municipal
  getTipoConselhoMunicipal () {
    return axios.get(`${seec_api}/conselho_municipal/tipo_conselho_municipal`)
  },

  // Legislação
  getLegislacao (params) {
    return axios.get(`${seec_api}/legislacao/legislacao`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getTipoLegislacao () {
    return axios.get(`${seec_api}/legislacao/tipo_legislacao`)
  },
  getAnoLegislacao () {
    return axios.get(`${seec_api}/legislacao/ano_legislacao`)
  },

  // Recursos Financeiros
  getAnoRecurso () {
    return axios.get(`${seec_api}/recurso_financeiro/ano_recurso`)
  },
  getFonteRecurso () {
    return axios.get(`${seec_api}/recurso_financeiro/fonte_recurso`)
  },
  getRecursosFinanceiros (params) {
    return axios.get(`${seec_api}/recurso_financeiro/recurso_financeiro`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },

  // SISPROFICE
  getEdital (params) {
    return axios.get(`${seec_api}/edital`, {
       params: params,
       paramsSerializer: params => qs.stringify(params, {
         arrayFormat: 'repeat',
         skipNulls: true
       })
    })
  },

  // Projetos Apresentados

  getProjetoApresentado (params) {
    return axios.get(`${seec_api}/sisprofice/projeto_apresentado`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getProjetoApresentadoOrcamento (params) {
    return axios.get(`${seec_api}/sisprofice/projeto_apresentado_orcamento`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },

  getProjetoSelecionado (params) {
    return axios.get(`${seec_api}/sisprofice/projeto_selecionado`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getProjetoSelecionadoOrcamento (params) {
    return axios.get(`${seec_api}/sisprofice/projeto_selecionado_orcamento`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },

  getProjetoContemplado (params) {
    return axios.get(`${seec_api}/sisprofice/projeto_contemplado`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getProjetoContempladoOrcamento (params) {
    return axios.get(`${seec_api}/sisprofice/projeto_contemplado_orcamento`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },

  // Locais de Realização

  getLocalRealizacao (params) {
    return axios.get(`${seec_api}/local_realizacao/local_realizacao`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getRealizacaoProjeto (params) {
    return axios.get(`${seec_api}/local_realizacao/realizacao_projeto`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },

  // Orçamentos de Projetos Solicitados

  getOrcamentoProjetoSolicitado (params) {
    return axios.get(`${seec_api}/sisprofice/orcamento_projeto_solicitado`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getOrcamentoProjetoProposta (params) {
    return axios.get(`${seec_api}/sisprofice/orcamento_projeto_proposta`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getOrcamentoProjetoContemplado (params) {
    return axios.get(`${seec_api}/sisprofice/orcamento_projeto_contemplado`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  // Atividades
  getAtividades (params) {
    return axios.get(`${seec_api}/atividades`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getGestores (params) {
    return axios.get(`${seec_api}/gestao_municipal/gestores`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getConselheiros (params) {
    return axios.get(`${seec_api}/gestao_municipal/conselheiros`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getTipoOrgaoGestor () {
    return axios.get(`${seec_api}/gestao_municipal/tipo_orgao_gestor`)
  }
}



export const equipamento = {
  getAtividades (params) {
    return axios.get(`${seec_api}/equipamentos/atividades`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat'
      })
    })
  },
  getEspecificacoes (equipamento) {
    return axios.get(`${seec_api}/equipamento/equipamento_especificacao`, {
      params: {
        equipamento: equipamento
      },
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat'
      })
    })
  },
  getRecursos (equipamento) {
    return axios.get(`${seec_api}/equipamento/equipamento_recurso`, {
      params: {
        equipamento: equipamento
      },
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat'
      })
    })
  },
  getServicos (equipamento) {
    return axios.get(`${seec_api}/equipamento/equipamento_servico`, {
      params: {
        equipamento: equipamento
      },
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat'
      })
    })
  },
}

export const sisprofice = {
  getSegmentos (params) {
    return axios.get(`${seec_api}/edital/segmento`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getAbrangencias (params) {
    return axios.get(`${seec_api}/edital/abrangencia`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getCategorias (params) {
    return axios.get(`${seec_api}/edital/categoria`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getFaixas (params) {
    return axios.get(`${seec_api}/edital/faixa`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getModalidades () {
    return axios.get(`${seec_api}/edital/modalidade`)
  },
  getEsferasAdministrativas () {
    return axios.get(`${seec_api}/edital/esfera-administrativa`)
  },
  getAreasCulturais (params) {
    return axios.get(`${seec_api}/area_cultural`, {
       params: params,
       paramsSerializer: params => qs.stringify(params, {
         arrayFormat: 'repeat',
         skipNulls: true
       })
    })
  },
  getPropostas (params) {
    return axios.get(`${seec_api}/sisprofice/proposta`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getPropostasMunicipio (params) {
    return axios.get(`${seec_api}/sisprofice/proposta-municipio`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },

  getEditalEsfera (params) {
    return axios.get(`${seec_api}/sisprofice/edital-esfera-administrativa`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getValorEdital (params) {
    return axios.get(`${seec_api}/sisprofice/valor-edital`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },
  getValorEsfera (params) {
    return axios.get(`${seec_api}/sisprofice/valor-esfera`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  }
}
